import React from 'react';
import { Button } from '../../ui/button';
import classes from './set-password-form.scss';
const CongratsView = ({
  onClose
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.successWrapper
}, /*#__PURE__*/React.createElement("h2", {
  className: classes.successTitle
}, "Congrats!"), /*#__PURE__*/React.createElement("span", {
  className: classes.successText
}, "You have successfully set your password."), /*#__PURE__*/React.createElement(Button, {
  type: "primary",
  className: classes.successCloseBtn,
  onClick: onClose
}, "Close"));
export default CongratsView;